module.exports = "<div *ngIf=\"start\" id=\"images\" class=\"slider_pos\">\n  <main>\n    <div id=\"container\">\n      <div id=\"gallery\">\n       <figure *ngFor=\"let image of images\">\n          <img onload=\"slideImages.init()\" class=\"slider\" src=\"{{image}}\" />\n        </figure>\n      </div>\n    </div>\n  </main>\n\n</div>\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/slider/slider.component.html
// module id = ../../../../../src/app/slider/slider.component.html
// module chunks = main